'use client';

import { useEffect } from 'react';

import { PopupTargetActionEvents } from '~containers/PopupResolver/PopupResolver.types';

type TargetActionHandler = (
  popupId: string,
  actionValue: string,
  options?: { shouldClose?: boolean; events?: PopupTargetActionEvents },
) => void;

export function usePopupTargetActionEvent(handler: TargetActionHandler) {
  useEffect(() => {
    const handleEvent = (e: Event) => {
      const detail = (e as CustomEvent).detail;

      if (detail?.popupId && detail?.actionValue) {
        handler(detail.popupId, detail.actionValue, {
          shouldClose: detail.shouldClose,
          events: detail.events,
        });
      }
    };

    window.addEventListener('popup:target-action', handleEvent);

    return () => {
      window.removeEventListener('popup:target-action', handleEvent);
    };
  }, [handler]);
}
